import { IChildProp } from '@intelligence/components/Form/type';

export const SEGMENT_PLATFORM_CASCADER: IChildProp[] = [
  {
    type: 'cascader',
    hasSelectAll: true,
    hasSearch: true,
    hasShortcut: true,
    mainCategory: 'dbi_data_source',
    subCategory: 'Detailed Platform',
    displaySearchParentText: true,
    searchTagAutoWidth: true,
    childWidth: 330,
    shortcutOptions: [
      {
        label: 'PC',
        labelKey: 'dbi_store_rank_console_pc',
        value: 'PC',
        includes: {
          mscience: ['PC'],
          gsd: ['PC'],
          npd: ['PC'],
          ampere: ['PC'],
          alinea: ['PC'],
          newzoo: ['PC'],
        },
      },
      {
        label: 'PlayStation',
        labelKey: 'dbi_store_rank_console_playstation',
        value: 'PlayStation,PlayStation 4,PlayStation 5',
        includes: {
          mscience: ['PlayStation'],
          gsd: ['PlayStation 4', 'PlayStation 5'],
          npd: ['PlayStation 4', 'PlayStation 5'],
          ampere: ['PlayStation'],
          alinea: ['PlayStation'],
          newzoo: ['PlayStation 4', 'PlayStation 5'],
        },
      },
      {
        label: 'Xbox',
        labelKey: 'dbi_store_rank_console_xbox',
        value: 'Xbox,Xbox Series X|S,Xbox One',
        includes: {
          mscience: ['Xbox'],
          gsd: ['Xbox Series X|S', 'Xbox One'],
          npd: ['Xbox Series X|S', 'Xbox One'],
          ampere: ['Xbox'],
          alinea: ['Xbox'],
          newzoo: ['Xbox Series X|S', 'Xbox One'],
        },
      },
      {
        label: 'Nintendo',
        labelKey: 'dbi_store_rank_console_nintendo',
        value: 'Nintendo,Nintendo Switch,WII U',
        includes: {
          mscience: ['Nintendo'],
          gsd: ['Nintendo Switch'],
          npd: ['Nintendo Switch', 'WII U'],
          newzoo: ['Nintendo Switch'],
        },
      },
    ],
    shortcutDefaultValue: '',
    children: [
      {
        enumKey: 'mscience',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pc',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playstation',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xbox',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'nintendo',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
      {
        enumKey: 'gsd',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pc',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation4',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation5',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxOne',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxSeriesxs',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'nintendoSwitch',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
      {
        enumKey: 'alinea',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pcSteam',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playstation',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xbox',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
      {
        enumKey: 'npd',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pc',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation4',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation5',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxOne',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxSeriesxs',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'nintendoSwitch',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'nintendoWiiU',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
      {
        enumKey: 'ampere',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pcSteam',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playstation',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xbox',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
      {
        enumKey: 'noUpdate',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'pc',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation4',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'playStation5',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxOne',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'xboxSeriesxs',
            enumTargetType: 'platformPCIcon',
          },
          {
            enumKey: 'nintendoSwitch',
            enumTargetType: 'platformPCIcon',
          },
        ],
      },
    ],
  },
];
